<template>
  <div class="overflow-hidden -mt-20">
    <div id="section-hero" class="hero">
      <div
        class="max-w-sm md:max-w-3xl md:px-4 lg:max-w-4xl xl:max-w-5xl w-full z-10"
      >
        <div
          id="section-hero-img"
          class="img-demo w-3/4 md:w-full md:h-full mt-10 rounded-xl mx-auto relative"
        >
          <img
            :src="require('~/assets/images/expert_screen.png')"
            alt="GoodMinds app profile expert preview"
            class="object-contain rounded-xl overflow-hidden"
          />
        </div>
        <h1
          id="section-hero-title"
          class="font-serif text-black px-6 sm:px-0 sm:max-w-lg md:max-w-2xl lg:max-w-6xl text-4xl md:text-6xl xl:text-8xl leading-none text-center mx-auto tracking-tight-plus mt-0 relative z-10"
        >
          Share your knowledge with curious people on 1:1 sessions
        </h1>
      </div>
    </div>
    <!-- hero advantages - setups steps -->
    <div id="section-advantages" class="container xl:max-w-5xl xl:px-0 mx-auto">
      <div
        class="flex flex-col md:flex-row flex-wrap items-center justify-center"
      >
        <div id="section-advantages-card-1" class="feature-card">
          <span>01</span>
          <h5>Create your profile.</h5>
          <p>
            An intro video, your price, your availability, that’s all. You now
            have your personnal page ready to share with the world.
          </p>
        </div>
        <div id="section-advantages-card-2" class="feature-card">
          <span>02</span>
          <h5>Make 1:1 calls.</h5>
          <p>
            Receive and accept booking demands. You’re ready. Answer questions
            or just chat, it’s up to you. Enjoy the conversation.
          </p>
        </div>
        <div id="section-advantages-card-3" class="feature-card">
          <span>03</span>
          <h5>Be paid right after the meeting.</h5>
          <p>
            Once the conversation is done, the money will be transfered to your
            account. All the payment are handled by Stripe.
          </p>
        </div>
      </div>
      <nuxt-link
        id="section-advantages-button"
        class="button-link pink flex items-center justify-center text-base mx-auto my-8"
        :to="{ name: 'experts-signup' }"
      >
        Get your profile in 1 min
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="ml-1 fill-current"
        >
          <path
            d="M12.393 8.66684H1.99967C1.82286 8.66684 1.65329 8.5966 1.52827 8.47157C1.40325 8.34655 1.33301 8.17698 1.33301 8.00017C1.33301 7.82336 1.40325 7.65379 1.52827 7.52877C1.65329 7.40374 1.82286 7.3335 1.99967 7.3335H12.393L8.85967 3.80017C8.79035 3.7399 8.73422 3.66595 8.69482 3.58297C8.65542 3.49999 8.6336 3.40975 8.63072 3.31794C8.62784 3.22612 8.64397 3.1347 8.67809 3.0494C8.71221 2.96411 8.76359 2.8868 8.82901 2.8223C8.89442 2.75781 8.97246 2.70753 9.05823 2.67462C9.14399 2.64171 9.23564 2.62688 9.3274 2.63106C9.41917 2.63524 9.50908 2.65835 9.5915 2.69892C9.67392 2.73949 9.74706 2.79666 9.80634 2.86684L14.473 7.5335C14.5952 7.65812 14.6636 7.82567 14.6636 8.00017C14.6636 8.17467 14.5952 8.34222 14.473 8.46684L9.80634 13.1335C9.67959 13.2437 9.51593 13.302 9.34806 13.2967C9.1802 13.2914 9.02051 13.223 8.90091 13.1051C8.78131 12.9872 8.71063 12.8285 8.70298 12.6607C8.69534 12.4929 8.7513 12.3285 8.85967 12.2002L12.393 8.66684V8.66684Z"
          />
        </svg>
      </nuxt-link>
    </div>

    <!-- section - knowledge -->
    <div
      id="section-knowledge"
      class="container mt-32 md:mt-48 xl:max-w-5xl xl:px-0 mx-auto flex flex-col md:flex-row"
    >
      <div>
        <h3
          id="section-knowledge-title"
          class="font-serif text-black text-4xl md:text-6xl xl:text-8xl leading-none tracking-tight-plus sm:max-w-lg md:max-w-xl xl:max-w-3xl whitespace-no-wrap"
        >
          Turn your knowledge<br />into helping others<br />— it’s rewarding.
        </h3>
        <p
          id="section-knowledge-text"
          class="text-base xl:text-xl text-gray-600 tracking-tight mt-6 leading-snug sm:max-w-md"
        >
          Your expertise is valuable, and it's not just about money. When you
          engage with curious people you help them understand better, move
          faster, and grow in the right direction. You have a direct impact on
          them. This is much more valuable than money.
        </p>
        <div id="section-knowledge-button" class="mx-auto my-10">
          <nuxt-link
            class="button-link pink text-base xl:text-xl tracking-tight leading-none"
            :to="{ name: 'experts-signup' }"
          >
            Join the beta now
          </nuxt-link>
        </div>
      </div>
      <!-- img demo -->
      <div id="section-knowledge-demo" class="demo-container md:mt-40">
        <div class="demo-video-container">
          <img :src="require('~/assets/images/demo-img.jpg')" alt="" />
        </div>
      </div>
    </div>

    <!-- Section - your content -->
    <section id="section-content" class="section-cards mt-32 md:mt-48">
      <div class="container xl:max-w-5xl xl:px-0 mx-auto">
        <!-- text -->
        <div>
          <h3
            id="section-content-title"
            class="font-serif text-black text-4xl md:text-6xl xl:text-8xl leading-none tracking-tight-plus sm:max-w-lg md:max-w-2xl xl:max-w-3xl"
          >
            Your page, your content,<br />— your community.
          </h3>
          <p
            id="section-content-text"
            class="text-base xl:text-xl text-gray-600 tracking-tight mt-6 leading-snug sm:max-w-md"
          >
            Make yourself available to answer questions from your followers,
            entrepreneurs, or just curious people. Set your price, your
            availability, and get paid right after the session. Answer their
            questions, or just chat, it's up to you, just have a great time.
          </p>
        </div>
        <!-- cards -->
        <div id="section-content-demo" class="cards-demo-container">
          <div id="section-content-demo-card-1" class="card-demo -mb-4">
            <p
              class="flex flex-row items-center justify-start text-xs font-medium leading-none text-green-600 mb-px"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current mr-1"
              >
                <path
                  d="M5.5 10V8.96C5.05683 8.88477 4.63622 8.71092 4.26928 8.45129C3.90233 8.19166 3.59842 7.85288 3.38 7.46C3.09103 7.51413 2.79371 7.50421 2.509 7.43094C2.22428 7.35767 1.95911 7.22283 1.73217 7.03594C1.50523 6.84905 1.32205 6.61465 1.19554 6.34927C1.06904 6.08388 1.00229 5.79398 1 5.5V3C1 2.45 1.45 2 2 2H3C3 1.45 3.45 1 4 1H8C8.26522 1 8.51957 1.10536 8.70711 1.29289C8.89464 1.48043 9 1.73478 9 2H10C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V5.5C11.0002 5.79497 10.9352 6.08634 10.8095 6.35323C10.6839 6.62011 10.5008 6.8559 10.2733 7.0437C10.0459 7.2315 9.77969 7.36666 9.49385 7.4395C9.20801 7.51234 8.9096 7.52105 8.62 7.465C8.40102 7.85695 8.09686 8.19475 7.72994 8.45349C7.36303 8.71224 6.94272 8.88533 6.5 8.96V10H8.5C8.63261 10 8.75978 10.0527 8.85355 10.1464C8.94732 10.2402 9 10.3674 9 10.5C9 10.6326 8.94732 10.7598 8.85355 10.8536C8.75978 10.9473 8.63261 11 8.5 11H3.5C3.36739 11 3.24021 10.9473 3.14645 10.8536C3.05268 10.7598 3 10.6326 3 10.5C3 10.3674 3.05268 10.2402 3.14645 10.1464C3.24021 10.0527 3.36739 10 3.5 10H5.5ZM8.96 6.5H9C9.26522 6.5 9.51957 6.39464 9.70711 6.20711C9.89464 6.01957 10 5.76522 10 5.5V3H9V6C9 6.17 8.985 6.335 8.96 6.5ZM3.04 6.5C3.01282 6.33473 2.99945 6.16749 3 6V3H2V5.5C1.99989 5.63476 2.02702 5.76814 2.07976 5.89215C2.1325 6.01616 2.20975 6.12823 2.30689 6.22163C2.40403 6.31503 2.51904 6.38784 2.64502 6.43567C2.771 6.48351 2.90535 6.50539 3.04 6.5ZM4 2V6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8C6.53043 8 7.03914 7.78929 7.41421 7.41421C7.78929 7.03914 8 6.53043 8 6V2H4Z"
                />
              </svg>

              Business
            </p>
            <p class="text-base font-medium text-black mt-1">
              How do I create a good culture?
            </p>
          </div>
          <div id="section-content-demo-card-2" class="card-demo -mb-4">
            <p
              class="flex flex-row items-center justify-start text-xs font-medium leading-none text-red-600 mb-px"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current mr-1"
              >
                <path
                  d="M5.5 10V8.96C5.05683 8.88477 4.63622 8.71092 4.26928 8.45129C3.90233 8.19166 3.59842 7.85288 3.38 7.46C3.09103 7.51413 2.79371 7.50421 2.509 7.43094C2.22428 7.35767 1.95911 7.22283 1.73217 7.03594C1.50523 6.84905 1.32205 6.61465 1.19554 6.34927C1.06904 6.08388 1.00229 5.79398 1 5.5V3C1 2.45 1.45 2 2 2H3C3 1.45 3.45 1 4 1H8C8.26522 1 8.51957 1.10536 8.70711 1.29289C8.89464 1.48043 9 1.73478 9 2H10C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V5.5C11.0002 5.79497 10.9352 6.08634 10.8095 6.35323C10.6839 6.62011 10.5008 6.8559 10.2733 7.0437C10.0459 7.2315 9.77969 7.36666 9.49385 7.4395C9.20801 7.51234 8.9096 7.52105 8.62 7.465C8.40102 7.85695 8.09686 8.19475 7.72994 8.45349C7.36303 8.71224 6.94272 8.88533 6.5 8.96V10H8.5C8.63261 10 8.75978 10.0527 8.85355 10.1464C8.94732 10.2402 9 10.3674 9 10.5C9 10.6326 8.94732 10.7598 8.85355 10.8536C8.75978 10.9473 8.63261 11 8.5 11H3.5C3.36739 11 3.24021 10.9473 3.14645 10.8536C3.05268 10.7598 3 10.6326 3 10.5C3 10.3674 3.05268 10.2402 3.14645 10.1464C3.24021 10.0527 3.36739 10 3.5 10H5.5ZM8.96 6.5H9C9.26522 6.5 9.51957 6.39464 9.70711 6.20711C9.89464 6.01957 10 5.76522 10 5.5V3H9V6C9 6.17 8.985 6.335 8.96 6.5ZM3.04 6.5C3.01282 6.33473 2.99945 6.16749 3 6V3H2V5.5C1.99989 5.63476 2.02702 5.76814 2.07976 5.89215C2.1325 6.01616 2.20975 6.12823 2.30689 6.22163C2.40403 6.31503 2.51904 6.38784 2.64502 6.43567C2.771 6.48351 2.90535 6.50539 3.04 6.5ZM4 2V6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8C6.53043 8 7.03914 7.78929 7.41421 7.41421C7.78929 7.03914 8 6.53043 8 6V2H4Z"
                />
              </svg>

              Design
            </p>
            <p class="text-base font-medium text-black mt-1">
              How can I improve my designs?
            </p>
          </div>
          <div id="section-content-demo-card-3" class="card-demo -mb-4">
            <p
              class="flex flex-row items-center justify-start text-xs font-medium leading-none text-indigo-600 mb-px"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current mr-1"
              >
                <path
                  d="M5.5 10V8.96C5.05683 8.88477 4.63622 8.71092 4.26928 8.45129C3.90233 8.19166 3.59842 7.85288 3.38 7.46C3.09103 7.51413 2.79371 7.50421 2.509 7.43094C2.22428 7.35767 1.95911 7.22283 1.73217 7.03594C1.50523 6.84905 1.32205 6.61465 1.19554 6.34927C1.06904 6.08388 1.00229 5.79398 1 5.5V3C1 2.45 1.45 2 2 2H3C3 1.45 3.45 1 4 1H8C8.26522 1 8.51957 1.10536 8.70711 1.29289C8.89464 1.48043 9 1.73478 9 2H10C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V5.5C11.0002 5.79497 10.9352 6.08634 10.8095 6.35323C10.6839 6.62011 10.5008 6.8559 10.2733 7.0437C10.0459 7.2315 9.77969 7.36666 9.49385 7.4395C9.20801 7.51234 8.9096 7.52105 8.62 7.465C8.40102 7.85695 8.09686 8.19475 7.72994 8.45349C7.36303 8.71224 6.94272 8.88533 6.5 8.96V10H8.5C8.63261 10 8.75978 10.0527 8.85355 10.1464C8.94732 10.2402 9 10.3674 9 10.5C9 10.6326 8.94732 10.7598 8.85355 10.8536C8.75978 10.9473 8.63261 11 8.5 11H3.5C3.36739 11 3.24021 10.9473 3.14645 10.8536C3.05268 10.7598 3 10.6326 3 10.5C3 10.3674 3.05268 10.2402 3.14645 10.1464C3.24021 10.0527 3.36739 10 3.5 10H5.5ZM8.96 6.5H9C9.26522 6.5 9.51957 6.39464 9.70711 6.20711C9.89464 6.01957 10 5.76522 10 5.5V3H9V6C9 6.17 8.985 6.335 8.96 6.5ZM3.04 6.5C3.01282 6.33473 2.99945 6.16749 3 6V3H2V5.5C1.99989 5.63476 2.02702 5.76814 2.07976 5.89215C2.1325 6.01616 2.20975 6.12823 2.30689 6.22163C2.40403 6.31503 2.51904 6.38784 2.64502 6.43567C2.771 6.48351 2.90535 6.50539 3.04 6.5ZM4 2V6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8C6.53043 8 7.03914 7.78929 7.41421 7.41421C7.78929 7.03914 8 6.53043 8 6V2H4Z"
                />
              </svg>

              Entrepreneurship
            </p>
            <p class="text-base font-medium text-black mt-1">
              How did you create your first company ?
            </p>
          </div>
          <div id="section-content-demo-card-4" class="card-demo -mb-4">
            <p
              class="flex flex-row items-center justify-start text-xs font-medium leading-none text-orange-600 mb-px"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current mr-1"
              >
                <path
                  d="M5.5 10V8.96C5.05683 8.88477 4.63622 8.71092 4.26928 8.45129C3.90233 8.19166 3.59842 7.85288 3.38 7.46C3.09103 7.51413 2.79371 7.50421 2.509 7.43094C2.22428 7.35767 1.95911 7.22283 1.73217 7.03594C1.50523 6.84905 1.32205 6.61465 1.19554 6.34927C1.06904 6.08388 1.00229 5.79398 1 5.5V3C1 2.45 1.45 2 2 2H3C3 1.45 3.45 1 4 1H8C8.26522 1 8.51957 1.10536 8.70711 1.29289C8.89464 1.48043 9 1.73478 9 2H10C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V5.5C11.0002 5.79497 10.9352 6.08634 10.8095 6.35323C10.6839 6.62011 10.5008 6.8559 10.2733 7.0437C10.0459 7.2315 9.77969 7.36666 9.49385 7.4395C9.20801 7.51234 8.9096 7.52105 8.62 7.465C8.40102 7.85695 8.09686 8.19475 7.72994 8.45349C7.36303 8.71224 6.94272 8.88533 6.5 8.96V10H8.5C8.63261 10 8.75978 10.0527 8.85355 10.1464C8.94732 10.2402 9 10.3674 9 10.5C9 10.6326 8.94732 10.7598 8.85355 10.8536C8.75978 10.9473 8.63261 11 8.5 11H3.5C3.36739 11 3.24021 10.9473 3.14645 10.8536C3.05268 10.7598 3 10.6326 3 10.5C3 10.3674 3.05268 10.2402 3.14645 10.1464C3.24021 10.0527 3.36739 10 3.5 10H5.5ZM8.96 6.5H9C9.26522 6.5 9.51957 6.39464 9.70711 6.20711C9.89464 6.01957 10 5.76522 10 5.5V3H9V6C9 6.17 8.985 6.335 8.96 6.5ZM3.04 6.5C3.01282 6.33473 2.99945 6.16749 3 6V3H2V5.5C1.99989 5.63476 2.02702 5.76814 2.07976 5.89215C2.1325 6.01616 2.20975 6.12823 2.30689 6.22163C2.40403 6.31503 2.51904 6.38784 2.64502 6.43567C2.771 6.48351 2.90535 6.50539 3.04 6.5ZM4 2V6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8C6.53043 8 7.03914 7.78929 7.41421 7.41421C7.78929 7.03914 8 6.53043 8 6V2H4Z"
                />
              </svg>

              Human Ressources
            </p>
            <p class="text-base font-medium text-black mt-1">
              How do I hire more engineer?
            </p>
          </div>
          <div id="section-content-demo-card-5" class="card-demo -mb-4">
            <p
              class="flex flex-row items-center justify-start text-xs font-medium leading-none text-yellow-600 mb-px"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current mr-1"
              >
                <path
                  d="M5.5 10V8.96C5.05683 8.88477 4.63622 8.71092 4.26928 8.45129C3.90233 8.19166 3.59842 7.85288 3.38 7.46C3.09103 7.51413 2.79371 7.50421 2.509 7.43094C2.22428 7.35767 1.95911 7.22283 1.73217 7.03594C1.50523 6.84905 1.32205 6.61465 1.19554 6.34927C1.06904 6.08388 1.00229 5.79398 1 5.5V3C1 2.45 1.45 2 2 2H3C3 1.45 3.45 1 4 1H8C8.26522 1 8.51957 1.10536 8.70711 1.29289C8.89464 1.48043 9 1.73478 9 2H10C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V5.5C11.0002 5.79497 10.9352 6.08634 10.8095 6.35323C10.6839 6.62011 10.5008 6.8559 10.2733 7.0437C10.0459 7.2315 9.77969 7.36666 9.49385 7.4395C9.20801 7.51234 8.9096 7.52105 8.62 7.465C8.40102 7.85695 8.09686 8.19475 7.72994 8.45349C7.36303 8.71224 6.94272 8.88533 6.5 8.96V10H8.5C8.63261 10 8.75978 10.0527 8.85355 10.1464C8.94732 10.2402 9 10.3674 9 10.5C9 10.6326 8.94732 10.7598 8.85355 10.8536C8.75978 10.9473 8.63261 11 8.5 11H3.5C3.36739 11 3.24021 10.9473 3.14645 10.8536C3.05268 10.7598 3 10.6326 3 10.5C3 10.3674 3.05268 10.2402 3.14645 10.1464C3.24021 10.0527 3.36739 10 3.5 10H5.5ZM8.96 6.5H9C9.26522 6.5 9.51957 6.39464 9.70711 6.20711C9.89464 6.01957 10 5.76522 10 5.5V3H9V6C9 6.17 8.985 6.335 8.96 6.5ZM3.04 6.5C3.01282 6.33473 2.99945 6.16749 3 6V3H2V5.5C1.99989 5.63476 2.02702 5.76814 2.07976 5.89215C2.1325 6.01616 2.20975 6.12823 2.30689 6.22163C2.40403 6.31503 2.51904 6.38784 2.64502 6.43567C2.771 6.48351 2.90535 6.50539 3.04 6.5ZM4 2V6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8C6.53043 8 7.03914 7.78929 7.41421 7.41421C7.78929 7.03914 8 6.53043 8 6V2H4Z"
                />
              </svg>

              Marketing
            </p>
            <p class="text-base font-medium text-black mt-1">
              What metrics are the best for my campaign ?
            </p>
          </div>
        </div>
      </div>
    </section>

    <Footer id="section-footer" class="z-10">
      <div class="container z-10">
        <div
          class="flex flex-col justify-center items-center mt-24 md:mt-40 mb-40"
        >
          <h2
            id="section-footer-title"
            class="font-serif text-black text-2xl md:text-4xl leading-none text-center tracking-tight mx-auto opacity-0"
          >
            Join our Private Beta
          </h2>
          <p
            id="section-footer-text"
            class="mt-4 max-w-xs md:max-w-lg mx-auto text-base leading-snug text-gray-600 text-center opacity-0"
          >
            GoodMinds is just getting started. You can create your profile and
            share it right await! Once it’s reviewed it’ll appear in the search
            results! Or
            <nuxt-link
              :to="{ name: 'username', params: { username: 'damien' } }"
              class="button-link hover-effect text-gray-600"
            >
              check out a demo
            </nuxt-link>
          </p>
          <div
            id="section-footer-button"
            class="mx-auto mt-8 md:mt-10 opacity-0"
          >
            <nuxt-link
              class="button-plain button-sm"
              :to="{ name: 'experts-signup' }"
            >
              Join the Beta
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current ml-2"
              >
                <path
                  d="M14.7168 10.2913H2.37467C2.16471 10.2913 1.96335 10.2079 1.81488 10.0595C1.66642 9.91101 1.58301 9.70965 1.58301 9.49968C1.58301 9.28972 1.66642 9.08836 1.81488 8.93989C1.96335 8.79142 2.16471 8.70802 2.37467 8.70802H14.7168L10.5209 4.51218C10.4386 4.44061 10.3719 4.3528 10.3252 4.25426C10.2784 4.15571 10.2525 4.04856 10.249 3.93953C10.2456 3.8305 10.2648 3.72193 10.3053 3.62065C10.3458 3.51937 10.4068 3.42755 10.4845 3.35096C10.5622 3.27438 10.6549 3.21467 10.7567 3.17559C10.8586 3.13651 10.9674 3.1189 11.0764 3.12387C11.1853 3.12883 11.2921 3.15627 11.39 3.20445C11.4878 3.25263 11.5747 3.32051 11.6451 3.40385L17.1868 8.94552C17.3318 9.0935 17.4131 9.29246 17.4131 9.49968C17.4131 9.7069 17.3318 9.90586 17.1868 10.0538L11.6451 15.5955C11.4946 15.7264 11.3002 15.7956 11.1009 15.7893C10.9015 15.7831 10.7119 15.7018 10.5699 15.5618C10.4279 15.4218 10.3439 15.2333 10.3349 15.0341C10.3258 14.8349 10.3922 14.6395 10.5209 14.4872L14.7168 10.2913V10.2913Z"
                  fill="white"
                />
              </svg>
            </nuxt-link>
          </div>
        </div>
      </div>
    </Footer>
  </div>
</template>

<script>
import { animateElementsTimeline } from '~/helpers';
import Footer from '~/components/Footer';

export default {
  transition: 'transition-fade',

  components: {
    Footer
  },

  mounted() {
    if (process.browser) {
      this.initAnimations();
    }
  },

  methods: {
    /**
     * Register every anim and launch them
     */
    initAnimations() {
      // animateElementsTimeline('#section-hero', [
      //   '#section-hero-img',
      //   '#section-hero-title'
      // ]);
      // section 2
      animateElementsTimeline('#section-advantages', [
        '#section-advantages-card-1',
        '#section-advantages-card-2',
        '#section-advantages-button',
        '#section-advantages-card-3'
      ]);

      animateElementsTimeline('#section-knowledge', [
        '#section-knowledge-title',
        '#section-knowledge-text',
        '#section-knowledge-button',
        '#section-knowledge-demo'
      ]);

      animateElementsTimeline('#section-content', [
        '#section-content-title',
        '#section-content-text'
      ]);

      animateElementsTimeline('#section-content-demo', [
        '#section-content-demo-card-1',
        '#section-content-demo-card-2',
        '#section-content-demo-card-3',
        '#section-content-demo-card-4',
        '#section-content-demo-card-5'
      ]);

      animateElementsTimeline('#section-footer', [
        '#section-footer-title',
        '#section-footer-text',
        '#section-footer-button'
      ]);
    }
  }
};
</script>

<style lang="postcss" scoped>
.hero {
  @apply flex flex-col justify-start items-center relative overflow-hidden;
  height: 550px;
  background-color: rgba(249, 249, 249, 0.7);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 90%, #ffffff 100%),
    rgba(249, 249, 249, 0.7);
  padding-top: 80px;

  @screen md {
    height: 900px;
    padding-top: 150px;
  }

  @screen lg {
    height: 1000px;
  }

  &::before {
    position: absolute;
    top: -250px;
    right: -350px;
    right: calc((100vw - 320px) / 2 - 400px);
    content: '';
    width: 600px;
    height: 600px;
    transform: rotate(120deg);
    opacity: 0.25;
    background-image: url('~assets/images/blur-3.png');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 0;

    @screen sm {
      top: -40%;
      top: -350px;
      right: -20%;
      right: calc((100vw - 768px) / 2 - 400px);
      width: 800px;
      height: 800px;
    }
    @screen xl {
      top: -30%;
      top: -250px;
      right: calc((100vw - 1280px) / 2 - 400px);
    }
  }
}

.img-demo {
  @apply shadow-2xl;
  position: relative;
  max-width: 643px;
  max-height: 442px;

  @screen md {
    box-shadow: 0px 0.913195px 4.51343px rgba(0, 0, 0, 0.0232426),
      0px 2.19453px 9.32472px rgba(0, 0, 0, 0.0296059),
      0px 4.13211px 15.0352px rgba(0, 0, 0, 0.0329147),
      0px 7.37098px 23.0322px rgba(0, 0, 0, 0.035353),
      0px 13.7866px 37.3659px rgba(0, 0, 0, 0.0386295),
      0px 33px 80px rgba(0, 0, 0, 0.05);
  }

  &::before {
    content: '';
    position: absolute;
    bottom: -10%;
    left: -10%;
    right: -10%;
    top: 60%;
    background: linear-gradient(180deg, rgba(249, 249, 249, 0) 0%, #f9f9f9 80%);
  }
}

.feature-card {
  @apply p-8 rounded-xl mb-10 relative bg-whitish overflow-hidden flex-1;
  max-width: 330px;

  @screen md {
    @apply mb-0 mr-8;
  }

  &:first-child {
    span {
      color: #e7e7f6;
    }
  }
  &:nth-child(2) {
    span {
      color: #fbeee4;
    }
  }
  &:nth-child(3) {
    @apply mb-0;

    @screen md {
      @apply mr-0;
    }
    span {
      color: #f6dde4;
    }
  }

  span {
    @apply text-6xl font-medium tracking-tighter leading-none;
    position: absolute;
    top: -20px;
    left: -20px;
    color: #fbeee4;
  }

  h5 {
    @apply text-sm font-medium text-black mt-6 leading-tight;

    @screen md {
      @apply text-base mt-12;
    }
  }
  p {
    @apply text-gray-600 text-sm leading-snug mt-3;
    @screen md {
      @apply text-base font-normal mt-6;
      line-height: 1.375rem;
    }
  }
}

/* Demo section */
.demo-container {
  @apply rounded-xl;
  .demo-video-container {
    @apply rounded-xl h-full bg-gray-100 relative mx-auto;
    width: 80%;
    max-width: 375px;
    max-height: 667px;
    box-shadow: 0px 25px 50px rgba(0, 0, 0, 0.25);

    @screen md {
      @apply w-full h-full;
    }

    img {
      @apply rounded-xl relative;
    }
    &::after {
      @apply absolute inset-0 w-full h-full rounded-xl;
      content: '';
      box-shadow: inset 0px 0px 90px rgba(0, 0, 0, 0.1),
        inset 0px 0px 10px rgba(0, 0, 0, 0.07);
    }
  }
}

/* Cards demo */
.section-cards {
  padding-bottom: 240px;
  position: relative;
  background: linear-gradient(
    180deg,
    rgba(249, 249, 249, 0) 30.73%,
    #f9f9f9 100%
  );

  .cards-demo-container {
    @apply relative max-w-sm mt-20 mx-auto;

    @screen md {
      @apply ml-auto mr-0 -mt-6;
    }

    .card-demo {
      @apply absolute py-5 px-6 rounded-xl;
      background-color: white;
      box-shadow: 0px 0.913195px 4.51343px rgba(0, 0, 0, 0.0232426),
        0px 2.19453px 9.32472px rgba(0, 0, 0, 0.0296059),
        0px 4.13211px 15.0352px rgba(0, 0, 0, 0.0329147),
        0px 7.37098px 23.0322px rgba(0, 0, 0, 0.035353),
        0px 13.7866px 37.3659px rgba(0, 0, 0, 0.0386295),
        0px 33px 80px rgba(0, 0, 0, 0.05);

      &:nth-child(1) {
        top: 0;
        left: 0;
        z-index: 12;
      }
      &:nth-child(2) {
        right: -20%;
        top: 56px;
        z-index: 10;
      }
      &:nth-child(3) {
        top: 100px;
        left: -140px;
        z-index: 9;
      }
      &:nth-child(4) {
        top: 142px;
        right: -40px;
        z-index: 8;
      }
      &:nth-child(5) {
        top: 185px;
        left: -20%;
        z-index: 7;
      }
    }
  }
}
</style>
